import { el } from "date-fns/locale";
import xor from "../../../../utils/xor";

const VALIDATION_MESSAGES = {
  'squareFootage_required': 'Home square footage is required',
  'attic_isChecked_checkOrNf': 'Attic Insultation requires to be checked OR NF code', 
  'caulking_wall_nf_nfAndChecks': 'Caulking Wall no checks allowed when NF selected.', 
  'caulking_window_nf_nfAndChecks': 'Caulking Window no checks allowed when NF selected.', 
  'caulking_door_nf_nfAndChecks': 'Caulking Door no checks allowed when NF selected.', 
  'squareFootage_numbers': 'Home square footage Numbers Only',
  'attic_isChecked_hasRValueIfChecked': 'Attic Insultation should have R value if it is checked', 
  'caulking_door_qty_qtyAndChecks': 'Please make sure the quantity and checkboxes are properly filled for Caulking door.', 
  'caulking_wall_qty_qtyAndChecks': 'Please make sure the quantity and checkboxes are properly filled for Caulking wall.', 
  'caulking_window_qty_qtyAndChecks': 'Please make sure the quantity and checkboxes are properly filled for Caulking Window.', 

  'aerator_bath_qty_qtyAndChecks': 'Faucet Aerator Bath quantity and checks.',
  "aerator_kitchen_qty_qtyAndChecks": 'Faucet Aerator Kitchen quantity and checks.',
  "aerator_qty_addUp": "Faucet and kitchen aerator quantities must add up to the value on the right side",

  "furnaceC&T_qty_qtyAndChecks": 'Furnace Clean and Tune (C&T) quantity and checks',
  "showerhead_handheld_qty_qtyAndChecks": 'Low Flow Showerhead Handheld quantity and checks',
  "showerhead_regular_qty_qtyAndChecks": 'Low Flow Showerhead Regular quantity and checks',
  "waterHeaterInsulationBlanket_qty_individualOrCentral": 'Water Heater Insulatation (Blanket) Individual or Central',

  "smartThermostat_serial2_validate": 'Smart Thermostat Serial2 validate',
  "casingCaulkingDoor_unit_validate": 'Casing w/Caulking- Door unit validate',
  "casingCaulkingWindow_unit_validate": 'Casing w/Caulking- Window unit validate',
  "doorJambCaulking_unit_validate": 'Door Jamb w/Caulking unit validate',

  "smartThermostat_qty_etc": 'Smart Thermostat: Please make sure you filled out the NF code OR scanned the serial numbers and added a quanitity.',

  "doorSC:24-36_qty": 'Door S/C- 24, 28, 30, 32, 36 quantity',
  "doorSC:34-42_qty": 'Door S/C- 34, 42 quantity',
  "doorStopCaulking_qty": "Door Stop w/Caulking quantity",
  "glassRepl:DS_qty": 'Glass Repl- DS quantity',

  "doorStopCaulking_unit": "Door Stop w/Caulking Lin. Ft",
  "glassRepl:DS_unit": 'Glass Repl- DS unit',
  "glassReplLouvered_unit": 'Glass Repl- Louvered',
  "glassReplPolycarbonate_unit": 'Glass Repl- Polycarbonated',
  "glassReplSpecialty_unit": 'Glass Repl- Specialty',
  "glassReplTempered_unit": 'Glass Repl- Tempered',

  "waterPressure_numbers": 'Water Pressure must always have a number',
  "leftNoticeOfCondition_isChecked": "Left Notice of Unsatisfactory Condition You need to select an appliance",
  "leftNoticeOfCondition_toBeChecked": "Left Notice of Unsatisfactory Condition You need to check Left Notice Unsatisfactory Condition",
  "leftNoticeOfCondition_isOther": "Left Notice of Unsatisfactory Condition You need to checkmark the other box.",
  "leftNoticeOfCondition_OtherText": "Left Notice of Unsatisfactory Condition You need to type something in field next to other box",
  "programIdBadgeNumber_numbers": "Program ID Badge Number Numbers only",
  "programIdBadgeNumber_required": "Program ID Badge Number Numbers required",
  "customerName_required": "Customer name required",
  "customerSignature_required": "Customer signature required",
  "installerName_required": "Installer name required",
  "installerSignature_required": "Installer Signature required"
} 

const useValidation = (control) => {
  const { getValues } = control;

  const hasQtyOrNf = (measureName, nfField) => (value) => xor(!!value, !!getValues(nfField)) || `${measureName} requires a Qty OR NF code`;
  // const aeratorQtyOrNf = (measureNameOne, measureNameTwo, nfField) => (value) => (xor(xor(!!value, !!getValues(nfField)), xor(!!getValues(measureNameTwo, !!getValues(nfField))))) || `${measureNameOne} requires a Qty OR NF code`;
  const aeratorQtyOrNf = (bathQty, kitchenQty, nfField) => (value) => xor((!!getValues(bathQty) || !!getValues(kitchenQty)), !!getValues(nfField)) || `Aerators need a qty or nf code`; 

  const nfEqualsZeroZero = (measureName) => value => {
    const additionalInfo = getValues('additionalInformation');
    return ((value !== '00' && value !== '0')) || (!!additionalInfo) || `${measureName} requires a comment since NF code is 00 or 0`;
  }

  const aeratorQtyMatch = (measureName) => value => {
    const bathQty = Number(getValues('aerator_bath_qty'));
    const kitchenQty = Number(getValues('aerator_kitchen_qty'));
    const addedQty = Number(value);
    console.log(kitchenQty, bathQty, addedQty);
    return (addedQty === (bathQty + kitchenQty) || VALIDATION_MESSAGES['aerator_qty_addUp'])
  }

  const hasLocationIfQty = (measureName, locationField) => (value) => ((!!value && !!getValues(locationField)) || !value)  || `${measureName} requires location when there is any quantity value`;

  return {
    "": () => ({
    }),
    "acCoverClipOn_nf": () => ({
      validate: {
        nfEqualsZeroZero: nfEqualsZeroZero('A/C Cover (Window/Wall) - Clip On'),
      },
    }),
    "acCoverMagnetic_nf": () => ({
      validate: {
        nfEqualsZeroZero: nfEqualsZeroZero('A/C Cover (Window/Wall) - Magnetic'),
      },
    }),
    "attic_nf": () => ({
      validate: {
        nfEqualsZeroZero: nfEqualsZeroZero('Attic Insulation')
      },
    }),
    "acCoverClipOn_qty": () => ({
      validate: {
        qtyOrNf: hasQtyOrNf("A/C Cover (Window/Wall)- Clip On", "acCoverClipOn_nf"),
        location: hasLocationIfQty("A/C Cover (Window/Wall)- Clip On", "acCoverClipOn_location") || 'Cover Clip On Location'
      },
    }),
    "acCoverMagnetic_qty": () => ({
      validate: {
        qtyOrNf: hasQtyOrNf("A/C Cover (Window/Wall)- Magnetic", "acCoverMagnetic_nf"),
        location: hasLocationIfQty("A/C Cover (Window/Wall)- Magnetic", "acCoverMagnetic_location") || 'Cover Magnetic Location',
      },
    }),
    "chhsc_nf": () => ({
      validate: {
        nfEqualsZeroZero: nfEqualsZeroZero('CHHSC')
      },
    }),
    "chhsc_qty": () => ({
      validate: {
        nfEqualsZeroZero: nfEqualsZeroZero('CHHSC'),
        qtyOrNf: hasQtyOrNf("CHHSC", "chhsc_nf"),
      },
    }),
    "attic_isChecked": () => ({
      validate: {
        checkOrNf: (isChecked) => xor(isChecked, !!getValues("attic_nf")) || VALIDATION_MESSAGES['attic_isChecked_checkOrNf'],
      },
    }),
    "caulking_door_qty": () => ({
      validate: {
        qtyOrNf: hasQtyOrNf("Caulking Door", "caulking_door_nf"),
        qtyAndChecks: (qty) => {
          const isDoor = getValues("caulking_door_isChecked");
          const isInterior = getValues("caulking_door_isInterior");
          const isExterior = getValues("caulking_door_isExterior");

          return ((!!qty && (isInterior || isExterior)) || !qty) || VALIDATION_MESSAGES['caulking_door_qty_qtyAndChecks'];
        },
      },
    }),
    "caulking_door_nf": () => ({
      validate: {
        nfEqualsZeroZero: nfEqualsZeroZero('Caulking Door NF', 'caulking_door_nf'),
        nfAndChecks: (nf) => {
          const isDoor = getValues("caulking_door_isChecked");
          const isInterior = getValues("caulking_door_isInterior");
          const isExterior = getValues("caulking_door_isExterior");
          return ((!!nf && !(isDoor || isInterior || isExterior)) || !nf) || VALIDATION_MESSAGES['caulking_door_nf_nfAndChecks'];
        },
      },
    }),
    "caulking_wall_qty": () => ({
      validate: {
        qtyOrNf: hasQtyOrNf("Caulking Wall", "caulking_wall_nf"),
        qtyAndChecks: (qty) => {
          const isDoor = getValues("caulking_wall_isChecked");
          const isInterior = getValues("caulking_wall_isInterior");
          const isExterior = getValues("caulking_wall_isExterior");

          return ((!!qty && (isInterior || isExterior)) || !qty) || VALIDATION_MESSAGES['caulking_wall_qty_qtyAndChecks'];
        },
      },
    }),
    "caulking_wall_nf": () => ({
      validate: {
        nfEqualsZeroZero: nfEqualsZeroZero('Caulking Wall NF'),
        nfAndChecks: (nf) => {
          const isDoor = getValues("caulking_wall_isChecked");
          const isInterior = getValues("caulking_wall_isInterior");
          const isExterior = getValues("caulking_wall_isExterior");
          return ((!!nf && !(isDoor || isInterior || isExterior)) || !nf) || VALIDATION_MESSAGES['caulking_wall_nf_nfAndChecks'];
        },
      },
    }),
    "caulking_window_qty": () => ({
      validate: {
        qtyOrNf: hasQtyOrNf("Caulking Window", "caulking_window_nf"),
        qtyAndChecks: (qty) => {
          const isDoor = getValues("caulking_window_isChecked");
          const isInterior = getValues("caulking_window_isInterior");
          const isExterior = getValues("caulking_window_isExterior");

          return ((!!qty && (isInterior || isExterior)) || !qty) || VALIDATION_MESSAGES['caulking_window_qty_qtyAndChecks'];
        },
      },
    }),
    "caulking_window_nf": () => ({
      validate: {
        nfEqualsZeroZero: nfEqualsZeroZero('Caulking Window NF'),
        nfAndChecks: (nf) => {
          const isDoor = getValues("caulking_window_isChecked");
          const isInterior = getValues("caulking_window_isInterior");
          const isExterior = getValues("caulking_window_isExterior");
          return ((!!nf && !(isDoor || isInterior || isExterior)) || !nf) || VALIDATION_MESSAGES['caulking_window_nf_nfAndChecks'];
        },
      },
    }),
    "evapCoolerRegisterCoverClipOn_qty": () => ({
      validate: {
        qtyOrNf: hasQtyOrNf("Evaporative Cooler Register Cover- Clip On", "evapCoolerRegisterCoverClipOn_nf"),
        location: hasLocationIfQty("Evaporative Cooler Register Cover- Clip On", "evapCoolerRegisterCoverClipOn_location"),
      },
    }),
    "evapCoolerRegisterCoverClipOn_nf": () => ({
      validate: {
        nfEqualsZeroZero: nfEqualsZeroZero('Evaporative Cooler Register Cover- Clip On')
      }
    }),
    "evapCoolerRegisterCoverMagnetic_qty": () => ({
      validate: {
        qtyOrNf: hasQtyOrNf("Evaporative Cooler Register Cover- Magnetic", "evapCoolerRegisterCoverMagnetic_nf"),
        location: hasLocationIfQty("Evaporative Cooler Register Cover- Magnetic", "evapCoolerRegisterCoverMagnetic_location"),
      },
    }),
    "evapCoolerRegisterCoverMagnetic_nf": () => ({
      validate: {
        nfEqualsZeroZero: nfEqualsZeroZero('Evaporative Cooler Register Cover- Magnetic')
      }
    }),
    // "aerators": () => ({
    //   validate: {
    //     qtyOrNf: hasQtyOrNf("Faucet Aerator Bath", "aerator_bath_nf"),
    //     qtyOrNf: hasQtyOrNf("Faucet Aerator Kitchen", "aerator_kitchen_nf")
    //   }
    // }),
    "aerator_qty": () => ({
      validate: {
        aeratorQtyMatch: aeratorQtyMatch('aerator_qty'),
      }
    }),
    "aerator_bath_qty": () => ({
      validate: {
        // qtyOrNf: (hasQtyOrNf("Faucet Aerator Bath", "aerator_nf"),
        aeratorQtyOrNf: aeratorQtyOrNf("aerator_bath_qty", "aerator_kitchen_qty", "aerator_nf"),
        qtyAndCheck: (qty) => ((!!qty === getValues("aerator_bath_isChecked")) || (!!getValues("aerator_kitchen_qty") && getValues("aerator_kitchen_isChecked"))) || VALIDATION_MESSAGES['aerator_bath_qty_qtyAndChecks'],
      },
    }),
    "aerator_nf": () => ({
      validate: {
        nfEqualsZeroZero: nfEqualsZeroZero('Faucet Aerator')
      }
    }),
    "aerator_kitchen_qty": () => ({
      validate: {
        // qtyOrNf: (hasQtyOrNf("Faucet Aerator Kitchen", "aerator_nf"),
        aeratorQtyOrNf: aeratorQtyOrNf("aerator_bath_qty", "aerator_kitchen_qty", "aerator_nf"),
        qtyAndCheck: (qty) => (!!qty === getValues("aerator_kitchen_isChecked")) || VALIDATION_MESSAGES['aerator_kitchen_qty_qtyAndChecks'],
      },
    }),
    "aerator_kitchen_nf": () => ({
      validate: {
        nfEqualsZeroZero: nfEqualsZeroZero('Faucet Aerator - Kitchen')
      }
    }),
    "furnaceC&T_qty": () => ({
      validate: {
        qtyOrNf: hasQtyOrNf("Furnace Clean and Tune (C&T)", "furnaceC&T_nf"),
        qtyAndCheck: (qty) => {
          const isWall = getValues("furnaceC&T_isWall");
          const isFloor = getValues("furnaceC&T_isFloor");
          const isFAU = getValues("furnaceC&T_isFAU");
          const isOther = getValues("furnaceC&T_isOther");

          return (!!qty === (isWall || isFloor || isFAU || isOther)) || VALIDATION_MESSAGES['furnaceC&T_qty_qtyAndChecks'];
        },
      },
    }),
    "furnaceC&T_nf": () => ({
      validate: {
        nfEqualsZeroZero: nfEqualsZeroZero('Furnace Clean and Tune (C&T)')
      }
    }),
    "showerhead_handheld_qty": () => ({
      validate: {
        qtyOrNf: hasQtyOrNf("Low Flow Showerhead Handheld", "showerhead_handheld_nf"),
        qtyAndCheck: (qty) => {
          const isHandheld = getValues("showerhead_handheld_isChecked");
          return (!!qty === isHandheld) || VALIDATION_MESSAGES['showerhead_handheld_qty_qtyAndChecks'];
        },
      },
    }),
    "showerhead_handheld_nf": () => ({
      validate: {
        nfEqualsZeroZero: nfEqualsZeroZero('Low Flow Showerhead - Handheld')
      }
    }),
    "showerhead_regular_qty": () => ({
      validate: {
        qtyOrNf: hasQtyOrNf("Low Flow Showerhead Regular", "showerhead_regular_nf"),
        qtyAndCheck: (qty) => {
          const isRegular = getValues("showerhead_regular_isChecked");
          return (!!qty === isRegular) || VALIDATION_MESSAGES['showerhead_regular_qty_qtyAndChecks'];
        },
      },
    }),
    "showerhead_regular_nf": () => ({
      validate: {
        nfEqualsZeroZero: nfEqualsZeroZero('Low Flow Showerhead - Regular')
      }
    }),
    "duct_nf": () => ({
      validate: (nf) => !!nf !== getValues("duct_isChecked") || 'Duct should be checked.',
      nfEqualsZeroZero: nfEqualsZeroZero('Prescriptive Duct Sealing')
    }),
    // "sprKit_qty": () => ({
    //   validate: {
    //     qtyOrNf: hasQtyOrNf("Standing Pilot Retrofit Kit (S.P.R.)", "sprKit_nf"),
    //     location: hasLocationIfQty("Standing Pilot Retrofit Kit (S.P.R.)", "sprKit_location"),
    //   },
    // }),
    // "sprKit_nf": () => ({
    //   validate: {
    //     nfEqualsZeroZero: nfEqualsZeroZero('Standing Pilot Retrofit Kit (S.P.R.)')
    //   }
    // }),
    "smartThermostat_qty": () => ({
      validate: {
        qtyOrNf: hasQtyOrNf("Smart Thermostat", "smartThermostat_nf"),
        etc: (qty) => {
          const make = getValues("smartThermostat_make");
          const model = getValues("smartThermostat_model");
          const serial1 = getValues("smartThermostat_serial1");

          return (((!!qty === !!make) === !!model) === !!serial1) || VALIDATION_MESSAGES['smartThermostat_qty_etc'];
        },
      },
    }),
    "smartThermostat_nf": () => ({
      validate: {
        nfEqualsZeroZero: nfEqualsZeroZero('Smart Thermostat')
      }
    }),
    "smartThermostat_serial2": () => ({
      validate: (serial2) => {
        const serial1 = getValues("smartThermostat_serial1");
        return (((!!serial1 && !!serial2) || !serial2) || '') || VALIDATION_MESSAGES['smartThermostat_serial2_validate'];
      },
    }),
    "switchOutletGasketCover_qty": () => ({
      validate: {
        qtyOrNf: hasQtyOrNf("Switch/Outlet Gaskets & Covers", "switchOutletGasketCover_nf"),
        location: hasLocationIfQty("Switch/Outlet Gaskets & Covers", "switchOutletGasketCover_location"),
      },
    }),
    "switchOutletGasketCover_nf": () => ({
      validate: {
        nfEqualsZeroZero: nfEqualsZeroZero('Switch/Outlet Gaskets & Covers')
      }
    }),
    "thermostaticShowerValve_qty": () => ({
      validate: {
        qtyOrNf: hasQtyOrNf("Thermostatic Shower Value", "thermostaticShowerValve_nf"),
        location: hasLocationIfQty("Thermostatic Shower Value", "thermostaticShowerValve_location"),
      },
    }),
    "thermostaticShowerValve_nf": () => ({
      validate: {
        nfEqualsZeroZero: nfEqualsZeroZero('Thermostatic Shower Valve')
      }
    }),
    "thermTubSpoutRegularShowerhead_qty": () => ({
      validate: {
        qtyOrNf: hasQtyOrNf("Thermostatic Tub Spout w/Regular Shower Head", "thermTubSpoutRegularShowerhead_nf"),
        location: hasLocationIfQty("Thermostatic Tub Spout w/Regular Shower Head", "thermTubSpoutRegularShowerhead_location"),
      },
    }),
    "thermTubSpoutRegularShowerhead_nf": () => ({
      validate: {
        nfEqualsZeroZero: nfEqualsZeroZero('Thermostatic Tub Spout w/Regular Shower Head')
      }
    }),
    "thermTubSpoutHandheldShowerhead_qty": () => ({
      validate: {
        qtyOrNf: hasQtyOrNf("Thermostatic Tub Spout w/Handheld Shower Head", "thermTubSpoutHandheldShowerhead_nf"),
        location: hasLocationIfQty("Thermostatic Tub Spout w/Handheld Shower Head", "thermTubSpoutHandheldShowerhead_location"),
      },
    }),
    "thermTubSpoutHandheldShowerhead_nf": () => ({
      validate: {
        nfEqualsZeroZero: nfEqualsZeroZero('Thermostatic Tub Spout w/Handheld Shower Head')
      }
    }),
    "waterHeaterInsulationBlanket_qty": () => ({
      validate: {
        qtyOrNf: hasQtyOrNf("Water Heater Insulation (Blanket)", "waterHeaterInsulationBlanket_nf"),
        individualOrCentral: () => {
          const isIndividual = getValues(
            "waterHeaterInsulationBlanket_isIndividual"
          );
          const isCentral = getValues("waterHeaterInsulationBlanket_isCentral");
          return !((isIndividual && isCentral) || (!isIndividual && !isCentral))  || VALIDATION_MESSAGES['waterHeaterInsulationBlanket_qty_individualOrCentral'];
        },
      },
    }),
    "waterHeaterInsulationBlanket_nf": () => ({
      validate: {
        nfEqualsZeroZero: nfEqualsZeroZero('Water Heater Insulation (Blanket)')
      }
    }),
    "waterHeaterPipeInsulation_qty": () => ({
      validate: {
        qtyOrNf: hasQtyOrNf("Water Heater Pipe Insulation (Wrap)", "waterHeaterPipeInsulation_nf"),
        location: hasLocationIfQty("Water Heater Pipe Insulation (Wrap)", "waterHeaterPipeInsulation_location"),
      },
    }),
    "waterHeaterPipeInsulation_nf": () => ({
      validate: {
        nfEqualsZeroZero: nfEqualsZeroZero('Water Heater Pipe Insulation (Wrap)')
      }
    }),
    "weatherstrippingAtticAccess_qty": () => ({
      validate: {
        qtyOrNf: hasQtyOrNf("Weatherstripping- Attic Access", "weatherstrippingAtticAccess_nf"),
        location: hasLocationIfQty("Weatherstripping- Attic Access", "weatherstrippingAtticAccess_location"),
      },
    }),
    "weatherstrippingAtticAccess_nf": () => ({
      validate: {
        nfEqualsZeroZero: nfEqualsZeroZero('Weatherstripping - Attic Access')
      }
    }),
    "weatherstrippingDoor_applDoorFoamTape_qty": () => ({
      validate: {
        qtyOrNf: hasQtyOrNf("Weatherstripping- Door Appl. Door- Foam Tape", "weatherstrippingDoor_applDoorFoamTape_nf"),
        location: hasLocationIfQty(
          "Weatherstripping- Door Appl. Door- Foam Tape", 
          "weatherstrippingDoor_applDoorFoamTape_location"
        ),
      },
    }),
    "weatherstrippingDoor_applDoorFoamTape_nf": () => ({
      validate: {
        nfEqualsZeroZero: nfEqualsZeroZero('Appl. Door - Foam Tape')
      }
    }),
    "weatherstrippingDoor_applDoorRigidGasket_qty": () => ({
      validate: {
        qtyOrNf: hasQtyOrNf("Weatherstripping- Door Appl. Door-Rigid Gasket", "weatherstrippingDoor_applDoorRigidGasket_nf"),
        location: hasLocationIfQty(
          "Weatherstripping- Door Appl. Door-Rigid Gasket", 
          "weatherstrippingDoor_applDoorRigidGasket_location"
        ),
      },
    }),
    "weatherstrippingDoor_applDoorRigidGasket_nf": () => ({
      validate: {
        nfEqualsZeroZero: nfEqualsZeroZero('Appl. Door - Rigid Gasket')
      }
    }),
    "weatherstrippingDoor_foamTapeVStrip_qty": () => ({
      validate: {
        qtyOrNf: hasQtyOrNf("Weatherstripping- Door Foam Tape/V Strip", "weatherstrippingDoor_foamTapeVStrip_nf"),
        location: hasLocationIfQty(
          "Weatherstripping- Door Foam Tape/V Strip", 
          "weatherstrippingDoor_foamTapeVStrip_location"
        ),
      },
    }),
    "weatherstrippingDoor_foamTapeVStrip_nf": () => ({
      validate: {
        nfEqualsZeroZero: nfEqualsZeroZero('Foam Tape/V Strip')
      }
    }),
    "weatherstrippingDoor_rigidGasket_qty": () => ({
      validate: {
        qtyOrNf: hasQtyOrNf("Weatherstripping- Door Rigid Gasket", "weatherstrippingDoor_rigidGasket_nf"),
        location: hasLocationIfQty("Weatherstripping- Door Rigid Gasket", "weatherstrippingDoor_rigidGasket_location"),
      },
    }),
    "weatherstrippingDoor_rigidGasket_nf": () => ({
      validate: {
        nfEqualsZeroZero: nfEqualsZeroZero('Rigid Gasket')
      }
    }),
    "weatherstrippingDoor_sliderPileSlidingGlass_qty": () => ({
      validate: {
        qtyOrNf: hasQtyOrNf("Weatherstripping- Door Slider Pile- (Sliding Glass)", "weatherstrippingDoor_sliderPileSlidingGlass_nf"),
        location: hasLocationIfQty(
          "Weatherstripping- Door Slider Pile- (Sliding Glass)", 
          "weatherstrippingDoor_sliderPileSlidingGlass_location"
        ),
      },
    }),
    "weatherstrippingDoor_sliderPileSlidingGlass_nf": () => ({
      validate: {
        nfEqualsZeroZero: nfEqualsZeroZero('Slider Pile - (Sliding Glass)')
      }
    }),
    "casingCaulkingDoor_unit": () => ({
      validate: (unit) => (!!unit === !!getValues("casingCaulkingDoor_qty")) || VALIDATION_MESSAGES['casingCaulkingDoor_unit_validate'],
    }),
    "casingCaulkingWindow_unit": () => ({
      validate: (unit) => (!!unit === !!getValues("casingCaulkingWindow_qty")) || VALIDATION_MESSAGES['casingCaulkingWindow_unit_validate'],
    }),
    "doorJambCaulking_unit": () => ({
      validate: (unit) => (!!unit === !!getValues("doorJambCaulking_qty")) || VALIDATION_MESSAGES['doorJambCaulking_unit_validate'],
    }),
    "doorSC:24-36_qty": () => ({
      validate: (qty) => {
        const is24 = getValues("doorSC:24-36_is24");
        const is28 = getValues("doorSC:24-36_is28");
        const is30 = getValues("doorSC:24-36_is30");
        const is32 = getValues("doorSC:24-36_is32");
        const is36 = getValues("doorSC:24-36_is36");

        return (!!qty === (is24 || is28 || is30 || is32 || is36)) || VALIDATION_MESSAGES['doorSC:24-36_qty'];
      },
    }),
    "doorSC:34-42_qty": () => ({
      validate: (qty) => {
        const is34 = getValues("doorSC:34-42_is34");
        const is42 = getValues("doorSC:34-42_is42");

        return (!!qty === (is34 || is42)) || VALIDATION_MESSAGES['doorSC:34-42_qty'];
      },
    }),
    "doorStopCaulking_qty": () => ({
      validate: (qty) => (!!qty === !!getValues("doorStopCaulking_unit")) || VALIDATION_MESSAGES['doorStopCaulking_qty']
    }),
    "doorStopCaulking_unit": () => ({
      validate: (unit) => (!!unit === !!getValues("doorStopCaulking_qty")) || VALIDATION_MESSAGES['doorStopCaulking_unit']
    }),
    "glassRepl:DS_qty": () => ({
      validate: (qty) => {
        const isDS = getValues("glassRepl:DS_isDS");

        return (!!qty === (isDS)) || VALIDATION_MESSAGES['glassRepl:DS_qty'];
      },
    }),
    "glassRepl:DS_unit": () => ({
      validate: (unit) => (!!unit === !!getValues("glassRepl:DS_qty")) || VALIDATION_MESSAGES['glassRepl:DS_unit']
    }),
    "glassReplLouvered_unit": () => ({
      validate: (unit) => (!!unit === !!getValues("glassReplLouvered_qty")) || VALIDATION_MESSAGES['glassReplLouvered_unit'],
    }),
    "glassReplPolycarbonate_unit": () => ({
      validate: (unit) => (!!unit === !!getValues("glassReplPolycarbonate_qty")) || VALIDATION_MESSAGES['glassReplPolycarbonate_unit'],
    }),
    "glassReplSpecialty_unit": () => ({
      validate: (unit) => (!!unit === !!getValues("glassReplSpecialty_qty")) || VALIDATION_MESSAGES['glassReplSpecialty_unit'],
    }),
    "glassReplTempered_unit": () => ({
      validate: (unit) => (!!unit === !!getValues("glassReplTempered_qty")) || VALIDATION_MESSAGES['glassReplTempered_unit'],
    }),
    "squareFootage": () => ({
      validate: {
        required: (squareFootage) => {
          return (!!squareFootage) || VALIDATION_MESSAGES["squareFootage_required"]
        },
        number: (squareFootage) => {
          return (!isNaN(squareFootage)) || VALIDATION_MESSAGES["squareFootage_numbers"]
        },
      }
    }),
    "psi": () => ({
      validate: (value) => {
        return (!isNaN(value) && !!value) || VALIDATION_MESSAGES["waterPressure_numbers"]
      }
    }),
    "leftNoticeOfCondition_isChecked": () => ({
      validate: (isChecked) => {
        const isFurnace = getValues("leftNoticeOfCondition_isFurnace");
        const isWaterHeater = getValues("leftNoticeOfCondition_isWaterHeater");
        const isOther = getValues("leftNoticeOfCondition_isOther");
        return (!!isChecked && (isFurnace || isWaterHeater || isOther)) || !isChecked || VALIDATION_MESSAGES['leftNoticeOfCondition_isChecked']
      },
    }),
    "leftNoticeOfCondition_isFurnace": () => ({
      validate: (isFurnace) => {
        const isChecked = getValues("leftNoticeOfCondition_isChecked");
        const isWaterHeater = getValues("leftNoticeOfCondition_isWaterHeater");
        const isOther = getValues("leftNoticeOfCondition_isOther");
        if (isFurnace || isWaterHeater || isOther)
          return (!!isChecked) || VALIDATION_MESSAGES['leftNoticeOfCondition_toBeChecked']
      },
    }),
    "leftNoticeOfCondition_isOther": () => ({
      validate: (isOther) => {
        const isChecked = getValues("leftNoticeOfCondition_isChecked");
        const otherText = getValues("leftNoticeOfConditionOtherText");
        if ((!!isChecked && !!otherText)) 
          return (isOther) || VALIDATION_MESSAGES['leftNoticeOfCondition_isOther']
      },
    }),
    "leftNoticeOfConditionOtherText": () => ({
      validate: (value) => {
        const isChecked = getValues("leftNoticeOfCondition_isChecked");
        const isOther = getValues("leftNoticeOfCondition_isOther");
        if ((!!isChecked && isOther)) 
          return !!value || VALIDATION_MESSAGES['leftNoticeOfCondition_OtherText']
      },
    }),
    "programIdBadgeNumber": () => ({
      validate: {
        required: (value) => {
          return (!!value) || VALIDATION_MESSAGES["programIdBadgeNumber_required"]
        },
        // number: (value) => (!isNaN(value)) || VALIDATION_MESSAGES["programIdBadgeNumber_numbers"]
      }
    }),
    "customerSignature": () => ({
      validate: {
        required: (signature) => {
          return (!!signature) || VALIDATION_MESSAGES["customerSignature_required"]
        }
      }
    }),
    "customerName": () => ({
      validate: {
        required: (customerName) => {
          return (!!customerName) || VALIDATION_MESSAGES["customerName_required"]
        }
      }
    }),
    "installerName": () => ({
      validate: {
        required: (installerName) => {
          return (!!installerName) || VALIDATION_MESSAGES["installerName_required"]
        }
      }
    }),
    "installerSignature": () => ({
      validate: {
        required: (installerSignature) => {
          return (!!installerSignature) || VALIDATION_MESSAGES["installerSignature_required"]
        }
      }
    }),
  };
};

export default useValidation;
